/**
 * 检测当前环境是否为浏览器环境
 *
 * @file detectClient
 * @author leibin@baijia.com
 */

var isClient = typeof window !== 'undefined';
export default isClient;